// extracted by mini-css-extract-plugin
export default {"wrapper":"TopicsList_wrapper__Yh6Zs","topicsTitle":"TopicsList_topicsTitle__kxsBu","container":"TopicsList_container__eKFUe","dropDown":"TopicsList_dropDown__fvcYI"};